
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { SubscriberGroupsState } from './types-store';
import { reducer as subscriberGroupsListReducer, INITIAL_STATE as subscriberGroupsListState } from './list/reducers';
import { reducer as subscriberGroupsFormReducer, INITIAL_STATE as subscriberGroupsFormState } from './form/reducers';
import { reducer as userMembersReducer, INITIAL_STATE as userMembersState } from './user-members/reducers';

export const INITIAL_STATE: SubscriberGroupsState = {
  list: subscriberGroupsListState,
  form: subscriberGroupsFormState,
  userMembers: userMembersState
};

export const reducer: Reducer<SubscriberGroupsState> = withOptionsReducer(
  STATE.subscriberGroups,
  mergeReducers({
    list: subscriberGroupsListReducer,
    form: subscriberGroupsFormReducer,
    userMembers: userMembersReducer
  })
);
